import image1 from '../../../../assets/images/work/sn-cas/CAS_detailed_img_1.jpg';
import image2 from '../../../../assets/images/work/sn-cas/CAS_detailed_img_2.jpg';
import image4 from '../../../../assets/images/work/sn-cas/CAS_detailed_abovefooter.jpg';

import artwork from '../../../../assets/images/art_2.png';

const Data_SNCAS = {
  content: (
    <>
      {/* PROBLEM + CHALLENGES */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                {/* PROBLEM */}
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">PROBLEM</h4>
                  <div className="paragraph light-1">
                    <p>
                      Science North set out to create an immersive, interactive climate experience that could educate,
                      inspire, and empower visitors of all ages to take meaningful climate action. The challenge was
                      delivering complex climate science in a way that felt personal, engaging, and participatory-while
                      supporting live show timing, real-time audience interaction, and touring reliability.
                    </p><br/>
                    <p>
                      The experience needed to scale across multiple venues, support hundreds of daily participants, and
                      seamlessly integrate storytelling, audience decision-making, and show automation into a single,
                      reliable system.
                    </p>
                  </div>
                </div>

                {/* CHALLENGES */}
                <div className="col-lg-6 second-column">
                  <h4 className="heading heading-small light-2">CHALLENGES</h4>
                  <div className="paragraph light-1">
                    <p>
                      Delivering a live, interactive theatre experience introduced significant technical complexity.
                      Audience choices needed to influence the show in real time, while maintaining tight control over
                      pacing, visuals, audio, and lighting. The system also had to support dozens of connected devices,
                      remain resilient during live performances, and operate consistently across touring and permanent
                      installations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PROJECT CONTENT */}
      <div className="project-content">
        <div className="project-content-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-large dark-1">
                    An interactive climate journey that turns audiences into active participants and future change agents.
                  </h2>

                  <div className="paragraph dark-1">
                    <p>
                      The Climate Action Show builds on Science North's award-winning climate programming, bringing audiences
                      into the climate barn alongside Sheepy, his niece Felicity, and a cast of global and local change
                      agents. Through a fast-paced, 19-minute immersive theatre experience, visitors explore the science
                      of climate change and discover how individual actions contribute to global impact.
                    </p><br/>
                    <p>
                      Using personal tablets, audience members interact with the show in real time-answering questions,
                      choosing which agents to consult, and influencing how the story unfolds. Every performance becomes a
                      shared, participatory experience driven by collective decision-making.
                    </p>
                  </div>

                  <div className="heading heading-medium dark-1">
                    <p>Technical Architecture & Live Control</p>
                  </div>

                  <div className="paragraph dark-1">
                    <p>
                      NORCAT was responsible for the complete technical backbone of the experience. We designed and
                      implemented a fully networked system that synchronized all on-screen content, interactive tablets,
                      and show automation. Large display systems supported real-time communication with Sheepy and
                      Felicity, and the main center show experience, while more than 30 Android tablets delivered individualized interactive experiences to
                      audience members during each show.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image-wrapper">
            <div className="single-image">
              <img src={image1} alt="Climate Action Show project screenshot 8" />
            </div>
            <div className="single-image">
              <img src={image2} alt="Climate Action Show project screenshot 9" />
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-medium dark-1">Systems Integration & Engagement</h2>

                  <div className="paragraph dark-1">
                    <p>
                      The system integrates directly with an Alcorn McBride show controller to manage lighting cues, show
                      timing, and environmental effects. Every component-from tablets to large-format displays-communicates
                      in real time, ensuring precise synchronization throughout each performance.
                    </p>
                    <p>
                      Beyond the live experience, NORCAT developed an online engagement platform that allows visitors to
                      continue exploring topics they connected with during the show. Users can create accounts, track
                      content of interest, and stay engaged with climate action initiatives supported by Science North's
                      science teams.
                    </p>
                  </div>

                  <div className="text-list medium dark-1">
                    <ul>
                      <li>Real-time audience-driven storytelling</li>
                      <li>Networked control of tablets, displays, and lighting systems</li>
                      <li>Automated show timing and touring reliability</li>
                      <li>Post-show digital engagement platform for continued learning</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image">
            <img src={image4} alt="Climate Action Show project screenshot 10" />
          </div>
        </div>
      </div>

      {/* RESULTS */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">RESULTS</h4>
                  <div className="paragraph light-1">
                    <p>
                      The Climate Action Show has successfully toured across Canada and is now permanently installed in
                      Sudbury, with international installations in Hong Kong and Singapore. The experience has engaged
                      thousands of visitors, transforming climate education into an interactive, action-oriented journey.
                    </p><br/>
                    <p>
                      By combining live theatre, audience interaction, and robust system automation, the project delivers
                      a scalable model for immersive science communication that continues to evolve alongside global
                      climate initiatives.
                    </p>
                  </div>
                </div>

                <div className="col-lg-5 offset-lg-1 second-column">
                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PLATFORM</h4>
                    <div className="heading heading-medium light-1">
                      <p>LBI</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">CLIENT</h4>
                    <div className="paragraph light-1">
                      <p>Science North</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">ONLINE</h4>
                    <div className="paragraph light-1">
                       <p><a href="https://www.sciencenorth.ca/" target="_blank" rel="noreferrer">
                          www.sciencenorth.ca
                        </a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-content-footer">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-md-6">
                  <h3 className="heading heading-large light-1">
                    Have an idea?
                    <br />
                    Let's explore it together.
                  </h3>
                </div>
                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                  <div className="button-wrapper">
                    <a className="button button-1" href="/Contact">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="artwork artwork-2" aria-hidden="true">
            <img src={artwork} alt="" />
          </div>
        </div>
      </div>
    </>
  ),
};

export default Data_SNCAS;


